const lityCustom = {

	$window: $(window),
	init() {
		let hash = window.location.hash;
		if(hash === '#reservations') {
			lity('#reservations');
		}
	},
	bindUIActions() {

	}
};

export { lityCustom };
